'use client'

import { useState } from 'react'

type LogoImageProps = {
  src: string
  alt: string
  className?: string
  fallbackClassName?: string
}

export function LogoImage({ src, alt, className, fallbackClassName }: LogoImageProps) {
  const [failed, setFailed] = useState(false)

  if (failed) {
    return <span className={fallbackClassName}>{alt}</span>
  }

  return (
    // eslint-disable-next-line @next/next/no-img-element
    <img src={src} alt={alt} className={className} loading="lazy" onError={() => setFailed(true)} />
  )
}
